import React, { useEffect, useMemo } from 'react';
import './FilePreview.css';

const FilePreview = ({ fileWrapper, onRemove, uploadInitiated, uploadComplete }) => {
  const { id, file, status, error } = fileWrapper;
  const isImage = file.type.startsWith('image/');
  const isVideo = file.type.startsWith('video/');
  const objectUrl = useMemo(() => URL.createObjectURL(file), [file]);

  useEffect(() => {
    // Revoke the object URL on component unmount
    return () => URL.revokeObjectURL(objectUrl);
  }, [objectUrl]);


  return (
    <div className={`file-preview status-${status}`}>
      {isImage && <img src={objectUrl} alt={file.name} />}
      {isVideo && (
        <video controls>
          <source src={objectUrl} type={file.type} />
          Your browser does not support the video tag.
        </video>
      )}
      <div className="file-info">
        <p>{file.name}</p>
        <p>{(file.size / 1024 / 1024).toFixed(2)} MB</p>
      </div>
      <div className="status-indicator">
        {status === 'pending' && uploadInitiated && <p>Pending</p>}
        {status === 'uploading' && <p>Uploading...</p>}
        {status === 'completed' && <p>Completed</p>}
        {status === 'failed' && <p className="error-message">Failed: {error}</p>}
      </div>
      <button onClick={() => onRemove(id)} disabled={uploadInitiated || uploadComplete}>Remove</button>
    </div>
  );
};

export default FilePreview;